module.exports = __webpack_public_path__ + "img/fischer.2347eab7.svg";